module.exports = __webpack_public_path__ + "static/media/New-York-Times-Logo8x6_0.48a0e045.png";